module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-100.d9e07d46.woff";